<template>
  <div>
    <b-container fluid>

      <b-row>
        <b-col>
          <h2>Cancelar ingressos <b-badge variant="light">{{ event.name }}</b-badge></h2>

          <b-alert
            class="my-2"
            :show="dismissCountDown"
            dismissible
            fade
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            Cancelado com sucesso.
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">Ingressos:</p>
            <b-form-checkbox-group v-model="filters.type">
              <b-form-checkbox-group v-model="filters.type" :options="typeOptions"></b-form-checkbox-group>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-v="end">
        <b-col>
          <div class="w-auto d-inline-block mr-4 mb-4">
            <p class="mb-2 font-weight-bold">Filtros:</p>
            <b-button class="mr-1 mb-1" v-b-modal.filter-origin>Origem</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-number>Número</b-button>
            <b-button v-if="!randomNumberEnabled" class="mr-1 mb-1" v-b-modal.filter-range>Intervalo</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-batch>Lote</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-dealer>Revendedor</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-payment-method>Forma Pag.</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-date>Data</b-button>
          </div>
          <div style="width: 110px;" class="d-inline-block mr-4 mb-4">
            <p class="mb-2 font-weight-bold">Quantidade:</p>
              <b-form-input size="sm" type="number" @input="updateForm('limit', $event)" :value="filters.limit"></b-form-input>
          </div>
          <div class="w-auto d-inline-block mr-4 mb-4">
            <b-button class="mr-1" variant="info" @click="showLast">Limpar filtros</b-button>
            <b-button class="mr-1" variant="info" @click="filter">Filtrar</b-button>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" v-if="hasFilters">
          <b-card-group>
            <b-card no-body>
              <b-list-group flush>
                <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                  <strong>{{ item.filter }}:</strong> {{ item.values }}
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
        </b-col>

        <b-col cols="12" class="mt-3">
          <p class="m-0">{{ stats }}</p>
        </b-col>

        <b-col cols="12" class="mt-3 mb-4">
          <b-table striped hover show-empty
            :items="tickets"
            :fields="fields"
            primary-key="number"
            empty-filtered-text="Nenhum ingresso encontrado"
            empty-text="Nenhum ingresso encontrado"
            responsive
            table-class="text-nowrap"
          >

            <template v-slot:head(chosenTickets)="">
              <b-form-checkbox
                v-model="selectAllTickets"
              ></b-form-checkbox>
            </template>

            <template v-slot:cell(statusStyled)="data">
              <div>
                <b-badge v-if="data.item.status === 'canceled'" pill variant="danger">Cancelado</b-badge>
                <b-badge v-else-if="data.item.status === 'validated'" pill variant="success">Validado</b-badge>
                <b-badge v-else pill variant="primary">Ativo</b-badge>
              </div>
            </template>

            <template v-slot:cell(eventName)="">
              {{ event.name }}
            </template>

            <template v-slot:cell(chosenTickets)="data">
              <b-form-checkbox
                v-model="chosenTickets"
                :value="data.item.number"
              ></b-form-checkbox>
            </template>

          </b-table>
        </b-col>
      </b-row>

    </b-container>

    <b-modal id="filter-origin"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Origem"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('origins', $event)"
          :checked="filters.origins"
          :options="originsOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-dealer"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Revendedor"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.dealer"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.dealer" @click="search.dealer = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('dealers', $event)"
          :checked="filters.dealers"
          :options="dealersOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>
    
    <b-modal id="filter-payment-method"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Forma Pag."
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('paymentMethods', $event)"
          :checked="filters.paymentMethods"
          :options="paymentMethodOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-batch"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Lote"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.batch"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.batch" @click="search.batch = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('batches', $event)"
          :checked="filters.batches"
          :options="batchesOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-number"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Número"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe os números e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('numbers', $event)"
          :value="filters.numbers"
          placeholder="Exemplo: 1,2,3"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.numbers" @click="filters.numbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-range"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Intervalo"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe o intervalo de números e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('rangeNumbers', $event)"
          :value="filters.rangeNumbers"
          placeholder="Exemplo: 1-25"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.rangeNumbers" @click="filters.rangeNumbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-date"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Data"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe a data inicial e/ou data final e clique em <span class="font-weight-bold">Filtrar</span></p>

      <div class="text-center">
        <calendar 
          @input="updateForm('createdAt', $event)"
          :value="filters.createdAt"
          :min-date="eventCreatedAt"
        >
        </calendar>
      </div>
    </b-modal>

    <b-modal id="cancel-confirm"
      scrollable
      centered
      ok-title="Continuar"
      ok-variant="success"
      cancel-title="Fechar"
      title="⚠️ Atenção"
      @ok="cancelConfirmAction"
    >

      <b-alert v-if="this.feedback.msg" show variant="danger">{{ this.feedback.msg }}</b-alert>

      <p><icon name="lock" scale="0.9"></icon> Você está prestes a cancelar <span class="font-weight-bold">{{ cancelMsgLabel }}</span>.</p>
      <p>Informe sua senha para continuar.</p>

      <b-form-input v-model="form.pass" type="password" autocomplete="off"></b-form-input>

    </b-modal>

    <b-container fluid class="fixed-bottom" v-if="chosenTickets.length > 0">
      <b-row>
        <b-col cols="12" lg="10" offset-lg="2">
          <b-alert show variant="info" dismissible fade class="mt-3" @dismissed="unselectTickets">
            {{ cancelBarLabel }}
            <b-button size="sm" class="mx-2" v-b-modal.cancel-confirm>Prosseguir</b-button>
          </b-alert>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask'
import FilterStore from '@/filterStore'
import Calendar from '@/components/Calendar'

export default {
  name: 'AdminTicketsCancel',
  components: {
    MaskedInput,
    Calendar
  },
  data () {
    return {
      currentStatus: null,
      totalTickets: 0,
      randomNumberEnabled: false,
      batches: [],
      dealers: [],
      tickets: [],
      event: '',
      appliedFilters: [],
      chosenTickets: [],
      filters: {
        limit: 10,
        dealers: [],
        batches: [],
        numbers: '',
        rangeNumbers: '',
        createdAt: {
          start: '',
          end: ''
        },
        type: ['printed', 'digital'],
        status: 'active',
        origins: [],
        paymentMethods: []
      },
      search: {
        dealer: '',
        batch: ''
      },
      fields: [
        { key: 'chosenTickets', label: '' },
        { key: 'number', label: 'Nro.', class: 'text-center' },
        { key: 'statusStyled', label: 'Status', formatter: this.$options.filters.ticketStatus, class: ['align-middle', 'text-center'] },
        { key: 'eventName', label: 'Evento' },
        { key: 'name', label: 'Lote' },
        { key: 'dealer', label: 'Revendedor' },
        { key: 'type', label: 'Tipo', formatter: this.$options.filters.ticketType, class: ['align-middle', 'text-center'] },
        { key: 'origin', label: 'Origem', formatter: this.$options.filters.ticketOrigin, class: ['align-middle', 'text-center'] },
        { key: 'payment_method', label: 'Forma Pag.', class: ['align-middle', 'text-center'] },
        { key: 'created_at', label: 'Data impressão', formatter: this.$options.filters.date }
      ],
      form: {
        pass: ''
      },
      feedback: {
        msg: ''
      },
      dismissSecs: 5,
      dismissCountDown: 0,
      originsOptions: [
        { text: 'Sistema', value: 'dashboard' },
        { text: 'Aplicativo', value: 'app' },
        { text: 'Loja virtual', value: 'shop' },
      ],
      typeOptions: [
        { text: 'Impressos', value: 'printed' },
        { text: 'Digitais', value: 'digital' },
      ],
      paymentMethodOptions: [
        { text: 'Débito', value: 'debt' },
        { text: 'Crédito à Vista', value: 'cred' },
        { text: 'Crédito Parcelado', value: 'cred_parc' },
        { text: 'Dinheiro', value: 'dinh' },
        { text: 'Pix', value: 'pix' },
        { text: 'Boleto', value: 'bol' },
      ],
      filterStore: '',
      eventCreatedAt: ''
    }
  },
  async mounted () {
    await this.getEvent(this.$route.params.id)
    await this.filter()
  },
  created () {
    this.filterStore = new FilterStore(this.$route.params.id, this.$route.path)
    this.filters = this.filterStore.merge(this.filters)
  },
  methods: {
    updateForm (input, value) {
      this.filters[input] = value
      this.filterStore.save(input, value) 
    },
    async getTickets (eventId, filters) {
      let url = process.env.VUE_APP_URL_APP + `/b/events/${eventId}/tickets`

      if (filters !== '' && filters !== undefined) {
        url = url + '?' + filters
      }

      try {
        let resp = await this.$http.get(url)
        this.tickets = resp.body.tickets
        this.event = resp.body.event
        return true
      } catch (e) {
        console.error(e)
      }
      return false
    },
    reset () {
      this.appliedFilters = []
      this.filters.dealers = []
      this.filters.batches = []
      this.filters.numbers = ''
      this.filters.rangeNumbers = ''
      this.filters.createdAt.start = ''
      this.filters.createdAt.end = ''
      this.filters.type = ['printed', 'digital']
      this.filters.status = 'active'
      this.filters.paymentMethods = []
      this.filters.origins = []
      this.filterStore.clear()
    },
    async getEvent (eventId) {
      let url = process.env.VUE_APP_URL_APP + `/b/events/${eventId}`

      try {
        let res = await this.$http.get(url)

        if (res.body.batches.length > 0) {
          this.batches = this.$_.orderBy(res.body.batches, ['id'], ['asc'])
        }

        if (res.body.dealers.length > 0) {
          this.dealers = this.$_.orderBy(res.body.dealers, ['id'], ['asc'])
        }

        this.totalTickets = res.body.print_amount - res.body.cancel_amount
        this.eventCreatedAt = this.$moment(res.body.created_at).format('YYYY-MM-DD 00:00:00')
        this.randomNumberEnabled = res.body.random_number_enabled === 1

        return true
      } catch (e) {
        console.error(e)
      }
      return false
    },
    async cancelConfirmAction (ctx) {
      ctx.preventDefault()

      let url = process.env.VUE_APP_URL_APP + `/b/admin/events/${this.$route.params.id}/tickets/cancel?numbers=${this.chosenTickets.join(',')}`
      let body = {
        login: this.$session.get('login'),
        pass: this.form.pass
      }

      try {
        let resp = await this.$http.put(url, body)

        if (resp.ok) {
          this.chosenTickets = []
          this.reset()
          this.getTickets(this.$route.params.id, 'limit=10&status=active')
          this.$bvModal.hide('cancel-confirm')
          this.showAlert()
        }
        return true
      } catch (e) {
        this.feedback.msg = e.body.message
        console.error(e)
      }
      return false
    },
    async filter () {
      let filters = []
      this.appliedFilters = []

      if (this.filters.dealers.length > 0) {
        filters.push('dealers=' + this.$_.join(this.filters.dealers, ','))

        let v = []
        this.$_.each(this.filters.dealers, f => {
          let s = this.$_.find(this.dealers, d => d.id === f)
          v.push(s.name)
        })
        let af = {
          filter: 'Revendedor',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.batches.length > 0) {
        filters.push('batches=' + this.$_.join(this.filters.batches, ','))

        let v = []
        this.$_.each(this.filters.batches, f => {
          let s = this.$_.find(this.batches, d => d.id === f)
          v.push(s.name)
        })
        let af = {
          filter: 'Lote',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.limit > 0) {
        filters.push('limit=' + this.filters.limit)
      }

      if (this.filters.numbers !== '') {
        filters.push('numbers=' + this.filters.numbers)

        let af = {
          filter: 'Número',
          values: this.filters.numbers
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.rangeNumbers !== '') {
        filters.push('range_numbers=' + this.filters.rangeNumbers)

        let split = this.$_.split(this.filters.rangeNumbers, '-', 2)

        let af = {
          filter: 'Intervalo',
          values: 'Do ' + split[0] + ' até o ' + split[1]
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.createdAt.start !== '') {
        let start = this.$moment(this.filters.createdAt.start, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('start_created_at=' + start + ':00')

        let af = {
          filter: 'Impressão',
          values: 'A partir de ' + this.filters.createdAt.start
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.createdAt.end !== '') {
        let end = this.$moment(this.filters.createdAt.end, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('end_created_at=' + end + ':59')

        let af = {
          filter: 'Impressão',
          values: 'Até ' + this.filters.createdAt.end
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.paymentMethods.length > 0) {
        filters.push('payment_methods=' + this.$_.join(this.filters.paymentMethods, ','))

        let v = []
        this.$_.each(this.filters.paymentMethods, f => {
          let s = this.$_.find(this.paymentMethodOptions, d => d.value === f)
          v.push(s.text)
        })
        let af = {
          filter: 'Forma Pag.',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.type.length > 0) {
        filters.push('type=' + this.$_.join(this.filters.type, ','))
      }

      if (this.filters.status !== '') {
        filters.push(`status=${this.filters.status}`)
      }

      if (this.filters.origins.length > 0) {
        filters.push('origins=' + this.$_.join(this.filters.origins, ','))

        let v = []
        this.$_.each(this.filters.origins, f => {
          let s = this.$_.find(this.originsOptions, d => d.value === f)
          v.push(s.text)
        })
        let af = {
          filter: 'Origem',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }

      await this.getTickets(this.$route.params.id, filters)
    },
    async showAll () {
      if (this.totalTickets > 500) {
        const action = await this.$bvModal.msgBoxConfirm(`Listar todos ingressos pode demorar alguns segundos.`, {
          title: '⚠ Atenção',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'Continuar',
          cancelTitle: 'Cancelar ',
          centered: true,
          hideHeaderClose: false
        })

        if (action === false || !action) {
          return false
        }
      }
      this.reset()
      await this.getTickets(this.$route.params.id)
    },
    async showLast () {
      this.reset()
      await this.getTickets(this.$route.params.id, 'limit=10&status=active')
    },
    unselectTickets () {
      this.chosenTickets = []
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  },
  computed: {
    dealersOptions () {
      let filtered = this.dealers

      if (this.search.dealer) {
        filtered = this.$_.filter(this.dealers, d => {
          let searched = this.search.dealer.toLowerCase()
          return d.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    batchesOptions () {
      let filtered = this.batches

      if (this.search.batch) {
        filtered = this.$_.filter(this.batches, b => {
          let searched = this.search.batch.toLowerCase()
          return b.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    hasFilters () {
      return this.appliedFilters.length !== 0
    },
    stats () {
      let qty = this.tickets.length

      if (qty === 1) {
        return `Exibindo 1 ingresso`
      } else if (qty > 1) {
        qty = this.$options.filters.number(qty)
        return `Exibindo ${qty} ingressos`
      }
      return ''
    },
    selectAllTickets: {
      get: function () {
        return this.tickets.length > 0 ? this.chosenTickets.length === this.tickets.length : false
      },
      set: function (value) {
        let selected = []

        if (value) {
          this.tickets.forEach(t => {
            selected.push(t.number)
          })
        }

        this.chosenTickets = selected
      }
    },
    cancelBarLabel () {
      let total = this.chosenTickets.length
      if (total > 1) {
        return `Prosseguir com o cancelamento de ${total} ingressos?`
      }
      return `Prosseguir com o cancelamento de ${total} ingresso?`
    },
    cancelMsgLabel () {
      let total = this.chosenTickets.length
      if (total > 1) {
        return `${total} ingressos`
      }
      return `${total} ingresso`
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown300 {
  width: 300px !important;
  overflow: hidden;
}
.cancel-bar {
  background-color: #f8d7da;
  color: #333;
  border-top: 1px solid #721c24;
}
</style>
